module.exports = __webpack_public_path__ + "static/media/question.8e050a42.svg";